var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6297 4.45946C7.66968 4.45946 4.45946 7.66968 4.45946 11.6297C4.45946 15.5897 7.66968 18.7999 11.6297 18.7999C13.6076 18.7999 15.3973 18 16.6953 16.7043C17.9963 15.4056 18.7999 13.6122 18.7999 11.6297C18.7999 7.66968 15.5897 4.45946 11.6297 4.45946ZM3 11.6297C3 6.86364 6.86364 3 11.6297 3C16.3957 3 20.2594 6.86364 20.2594 11.6297C20.2594 13.7518 19.4926 15.696 18.2222 17.1986L20.7854 19.7534C21.0709 20.0379 21.0716 20.5 20.7871 20.7854C20.5026 21.0709 20.0406 21.0716 19.7551 20.7871L17.1895 18.2299C15.6882 19.4957 13.7476 20.2594 11.6297 20.2594C6.86364 20.2594 3 16.3957 3 11.6297Z",
    fill: "#4E5566"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMarket);
export default __webpack_public_path__ + "static/media/SearchMarket.3a547b34000c270dfec8a5853f9f3354.svg";
export { ForwardRef as ReactComponent };